export const SDK_VERSION = '7.23.0';
